import Players from '@/services/player/Players';
import PresetCommunityCards from '@/services/PresetCommunityCards';
import shareUrlService from '@/services/share-url-service';
import storeService from '@/store/service';

let state = {
  players: new Players(),
  presetCommunityCards: new PresetCommunityCards(),
  openSize: 3,
  threeBetSize: 9,
  numPlayersLeftToAct: 3,
  averageFourBetPercentage: 1,
  cbetSize: 0.5,
  continueVsCbetPercentage: 50,
  hitPercentage: 5,
  firstStreetOfValuePercentage: 50,
  secondStreetOfValuePercentage: 50,
  thirdStreetOfValuePercentage: 50,
  alternativeEV: 0,
};

let mutations = {
  setState: function (state, stateFromServer) {
    shareUrlService.setThreeBetCbetStoreState(stateFromServer, state);
  },

  // player range
  selectGeneralHand: function (state, payload) {
    storeService.selectGeneralHand(state, payload);
  },
  deselectGeneralHand: function (state, payload) {
    storeService.deselectGeneralHand(state, payload);
  },
  manuallySelectGeneralHand: function (state, payload) {
    storeService.manuallySelectGeneralHand(state, payload);
  },
  manuallyDeselectGeneralHand: function (state, payload) {
    storeService.manuallyDeselectGeneralHand(state, payload);
  },
  selectGeneralHands: function (state, payload) {
    storeService.selectGeneralHands(state, payload);
  },
  deselectGeneralHands: function (state, payload) {
    storeService.deselectGeneralHands(state, payload);
  },
  manuallyDeselectAllGeneralHands: function (state, payload) {
    storeService.manuallyDeselectAllGeneralHands(state, payload);
  },
  selectSpecificHands: function (state, payload) {
    storeService.selectSpecificHands(state, payload);
  },
  deselectAllGeneralHands: function (state, payload) {
    storeService.deselectAllGeneralHands(state, payload);
  },
  applyExactWeightToGeneralHand: function (state, payload) {
    storeService.applyExactWeightToGeneralHand(state, payload);
  },
  applyExactWeightToGeneralHands: function (state, payload) {
    storeService.applyExactWeightToGeneralHands(state, payload);
  },
  manuallyApplyExactWeightToGeneralHand: function (state, payload) {
    storeService.manuallyApplyExactWeightToGeneralHand(state, payload);
  },

  // player other
  setWeightToApplyToAddedHands: function (state, payload) {
    storeService.setWeightToApplyToAddedHands(state, payload);
  },

  // other
  setOpenSize: function (state, openSize) {
    state.openSize = openSize;
  },
  setThreeBetSize: function (state, threeBetSize) {
    state.threeBetSize = threeBetSize;
  },
  setNumPlayersLeftToAct: function (state, numPlayersLeftToAct) {
    state.numPlayersLeftToAct = numPlayersLeftToAct;
  },
  setAverageFourBetPercentage: function (state, averageFourBetPercentage) {
    state.averageFourBetPercentage = averageFourBetPercentage;
  },
  setCbetSize: function (state, cbetSize) {
    state.cbetSize = cbetSize;
  },
  setContinueVsCbetPercentage: function (state, continueVsCbetPercentage) {
    state.continueVsCbetPercentage = continueVsCbetPercentage;
  },
  setHitPercentage: function (state, hitPercentage) {
    state.hitPercentage = hitPercentage;
  },
  setFirstStreetOfValuePercentage: function (state, firstStreetOfValuePercentage) {
    state.firstStreetOfValuePercentage = firstStreetOfValuePercentage;
  },
  setSecondStreetOfValuePercentage: function (state, secondStreetOfValuePercentage) {
    state.secondStreetOfValuePercentage = secondStreetOfValuePercentage;
  },
  setThirdStreetOfValuePercentage: function (state, thirdStreetOfValuePercentage) {
    state.thirdStreetOfValuePercentage = thirdStreetOfValuePercentage;
  },
  setAlternativeEV: function (state, alternativeEV) {
    state.alternativeEV = alternativeEV;
  },
};

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
};

export { state, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/three-bet-cbet-explorer/three-bet-cbet-explorer.js